export const GET_USER_PHONES_REQUEST = 'GET_USER_PHONES_REQUEST';
export const GET_USER_PHONES_REQUEST_SUCCESS = 'GET_USER_PHONES_REQUEST_SUCCESS';
export const GET_USER_PHONES_REQUEST_FAILURE = 'GET_USER_PHONES_REQUEST_FAILURE';

export const CHANGE_USER_PHONE_REQUEST = 'CHANGE_USER_PHONE_REQUEST';
export const CHANGE_USER_PHONE_SUCCESS = 'CHANGE_USER_PHONE_SUCCESS';
export const CHANGE_USER_PHONE_FAILURE = 'CHANGE_USER_PHONE_FAILURE';

export const CREATE_USER_PHONE_REQUEST = 'CREATE_USER_PHONE_REQUEST';
export const CREATE_USER_PHONE_SUCCESS = 'CREATE_USER_PHONE_SUCCESS';
export const CREATE_USER_PHONE_FAILURE = 'CREATE_USER_PHONE_FAILURE';

export const REMOVE_USER_PHONE_REQUEST = 'REMOVE_USER_PHONE_REQUEST';
export const REMOVE_USER_PHONE_SUCCESS = 'REMOVE_USER_PHONE_SUCCESS';
export const REMOVE_USER_PHONE_FAILURE = 'REMOVE_USER_PHONE_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/constants/user_phones.constants.js